import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export function createRouter () {
  return new Router({
    mode: 'history',
    routes: [
      {
        path: '/home',
        name: 'home',
        component: () => import('./views/Home.vue')
      },
      {
        path: '/',
        name: 'home',
        component: () => import('./views/Home.vue')
      },
      {
        path: '/about',
        name: 'about',
        component: () =>
          import('./views/About.vue')
      },
      {
        path: '/product',
        name: 'product',
        component: () =>
          import('./views/Product.vue')
      },
      {
        path: '/cooperation',
        name: 'cooperation',
        component: () =>
          import('./views/Cooperation.vue')
      }
    ]
  })
}
